// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c6b48a74","239":"0c021de2","455":"ecf1f651"}[chunkId] + ".chunk.js";
};